import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

interface SignSummary {
  contractNo: string | null; title: string | null; customerName: string | null;
  providerName: string; status: string; signerName: string | null; alreadySigned: boolean;
}

@Component({
  selector: 'app-sign-page',
  templateUrl: './sign-page.component.html',
  styleUrls: ['./sign-page.component.css'],
})
export class SignPageComponent implements OnInit {
  token = '';
  loading = true;
  invalid = false;
  summary: SignSummary | null = null;

  signerName = '';
  agreed = false;
  signature: string | null = null;
  saving = false;
  done = false;
  error = '';

  constructor(private http: HttpClient, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') ?? '';
    this.http.get<SignSummary>(`/api/sign/${this.token}`).subscribe({
      next: s => {
        this.summary = s; this.loading = false;
        this.signerName = s.signerName ?? s.customerName ?? '';
        this.done = s.alreadySigned;
      },
      error: () => { this.loading = false; this.invalid = true; },
    });
  }

  viewPdf(): void {
    this.http.get(`/api/sign/${this.token}/pdf`, { responseType: 'blob' }).subscribe({
      next: b => window.open(URL.createObjectURL(b), '_blank'),
      error: () => {},
    });
  }

  onSignature(png: string | null): void { this.signature = png; }

  get canSign(): boolean {
    return !!this.signerName.trim() && !!this.signature && this.agreed && !this.saving;
  }

  submit(): void {
    if (!this.canSign) return;
    this.saving = true; this.error = '';
    this.http.post(`/api/sign/${this.token}`, {
      signerName: this.signerName.trim(),
      signatureImage: this.signature,
    }).subscribe({
      next: () => { this.saving = false; this.done = true; },
      error: (e: any) => { this.saving = false; this.error = e?.error?.error || 'Failed to sign.'; },
    });
  }
}
